import { invalidatePromptLists } from '../api/trackerAiClient';
import type { EnqueuePromptRunsResult, PromptRunBatchStatus } from '../types';
import { DUPLICATE_EXECUTION_MESSAGE } from './api-errors';

const TERMINAL_BATCH_STATUS = new Set(['completed', 'failed', 'partial']);

export function isTerminalPromptRunBatch(status: string): boolean {
  return TERMINAL_BATCH_STATUS.has(status);
}

export function batchRunPercent(status: PromptRunBatchStatus): number {
  const runnable = Math.max(0, status.totalCount - status.skippedCount);
  const done = status.completedCount + status.failedCount;
  if (runnable === 0 || done >= runnable) return 100;
  return Math.min(99, Math.floor((done / runnable) * 100));
}

export function enqueueRunErrorMessage(
  result: EnqueuePromptRunsResult,
): string | null {
  if (result.createdItems === 0 && result.skippedItems > 0) {
    return DUPLICATE_EXECUTION_MESSAGE;
  }
  if (result.total === 0) {
    return 'پرامپتی برای اجرا پیدا نشد';
  }
  return null;
}

/** Poll list/row refresh while workers finish queued jobs. */
export function schedulePromptRunRefresh(
  refresh: () => void | Promise<void>,
  delaysMs: number[] = [3000, 10000, 25000],
): void {
  for (const delay of delaysMs) {
    setTimeout(() => {
      invalidatePromptLists();
      void refresh();
    }, delay);
  }
}
